export const NumberInputActionTypes = {
  clamp: 'numberInput:clamp',
  inputChange: 'numberInput:inputChange',
  increment: 'numberInput:increment',
  decrement: 'numberInput:decrement',
  decrementToMin: 'numberInput:decrementToMin',
  incrementToMax: 'numberInput:incrementToMax',
  resetInputValue: 'numberInput:resetInputValue'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/base/unstable_useNumberInput/numberInputAction.types.js
// module id = 1134
// module chunks = 0